//Version:0.0.1
//Author:Harsha
//Last Edit:Harsha
//Modified Date:26-08-2025
import { takeLatest, put, all, call } from 'redux-saga/effects';
import InstrumentActionTypes from './instrument.types';
import {
	getAllListInstrument,
	createInstrumentDetails,
	getInstrumentInfo,
	updateInstrumentDetails,
	deleteInstrumentDetails,
} from './instrument.service';
import { encryptData } from '../../../_common/enode-decode';
import AlertManager from '../../../../utils/alertManager';
import {
	// GET INSTRUMENT LIST RESPONSE
	getInstrumentListSuccess,
	getInstrumentListFailure,
	getInstrumentListResponseChanged,
	// CREATE INSTRUMENT RESPONSE
	createInstrumentSuccess,
	createInstrumentFailure,
	createInstrumentResponseChanged,
	// GET INSTRUMENT LIST RESPONSE
	getParticularInstrumentSuccess,
	getParticularInstrumentFailure,
	getParticularInstrumentResponseChanged,
	// UPDATE INSTRUMENT RESPONSE
	updateInstrumentSuccess,
	updateInstrumentFailure,
	updateInstrumentResponseChanged,
	// DELETE INSTRUMENT RESPONSE
	deleteInstrumentSuccess,
	deleteInstrumentFailure,
	deleteInstrumentResponseChanged,
} from './instrument.action';

/*********************** START - GET ALL INSTRUMENT LIST *********************/
export function* getAllInstruments({ payload }: any) {
	try {
		const key = 'GetInstrumentListDetailsKey';
		const { infogCompanyID, databaseName, inputSearch, limitcount } = payload;
		const jsonData = {
			CompanyID: infogCompanyID,
			DatabaseName: databaseName,
			InputSearch: inputSearch,
			Limit: limitcount,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(getAllListInstrument, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(getInstrumentListFailure(responseData.data));
		} else {
			yield put(getInstrumentListSuccess(responseData.data));
		}
	} catch (error) {
		yield put(getInstrumentListFailure(error));
	}
}

export function* resetGetInstrumentListResponse() {
	yield put(getInstrumentListResponseChanged());
}

export function* onGetAllInstruments() {
	yield takeLatest(InstrumentActionTypes.GET_INSTRUMENT_LIST_START, getAllInstruments);
}

export function* onGetAllInstrumentResponseReset() {
	yield takeLatest(
		InstrumentActionTypes.GET_INSTRUMENT_LIST_RESPONSE_RESET,
		resetGetInstrumentListResponse,
	);
}
/************************* END - GET ALL INSTRUMENT LIST ************************/

/*********************** START - CREATE INSTRUMENT DETAILS **********************/
export function* CreateInstrument({ payload }: any) {
	try {
		const key = 'CreateInstrumentListDetailsKey';
		const { infogCompanyID, instrumentName, databaseName } = payload;
		const jsonData = {
			CompanyID: infogCompanyID,
			InstrumentName: instrumentName,
			DatabaseName: databaseName,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(createInstrumentDetails, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(createInstrumentFailure(responseData.data));
		} else {
			yield put(createInstrumentSuccess(responseData.data));
		}
	} catch (error) {
		yield put(createInstrumentFailure(error));
	}
}

export function* resetCreateInstrumentResponseReset() {
	yield put(createInstrumentResponseChanged());
}

export function* onCreateInstrument() {
	yield takeLatest(InstrumentActionTypes.CREATE_INSTRUMENT_START, CreateInstrument);
}

export function* onCreateInstrumentResponseReset() {
	yield takeLatest(
		InstrumentActionTypes.CREATE_INSTRUMENT_RESPONSE_RESET,
		resetCreateInstrumentResponseReset,
	);
}

/************************* END - CREATE INSTRUMENT DETAILS ************************/

/******************** START - GET PARTICULAR INSTRUMENT DETAILS *******************/
export function* getParticularInstrument({ payload }: any) {
	try {
		const key = 'GetParticularInstrumentListDetailsKey';
		const { infogCompanyID, instrumentID, databaseName } = payload;
		const jsonData = {
			InfogID: infogCompanyID,
			InstrumentID: instrumentID,
			DatabaseName: databaseName,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore

		const responseData = yield call(getInstrumentInfo, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(getParticularInstrumentFailure(responseData.data));
		} else {
			yield put(getParticularInstrumentSuccess(responseData.data));
		}
	} catch (error) {
		yield put(getParticularInstrumentFailure(error));
	}
}

export function* resetGetParticularInstrumentResponse() {
	yield put(getParticularInstrumentResponseChanged());
}

export function* onGetParticularInstrument() {
	yield takeLatest(
		InstrumentActionTypes.GET_PARTICULAR_INSTRUMENT_START,
		getParticularInstrument,
	);
}

export function* ongetParticularInstrumentResponseReset() {
	yield takeLatest(
		InstrumentActionTypes.GET_PARTICULAR_INSTRUMENT_RESPONSE_RESET,
		resetGetParticularInstrumentResponse,
	);
}
/********************** END - GET PARTICULAR INSTRUMENT DETAILS **********************/

/************************* START - DELETE INSTRUMENT DETAILS *************************/
export function* deleteInstrument({ payload }: any) {
	try {
		const key = 'DeleteInstrumentDetailsKey';
		const { infogCompanyID, instrumentID, userID, userName, databaseName } = payload;
		const jsonData = {
			InstrumentID: instrumentID,
			InfogID: infogCompanyID,
			UserName: userName,
			UserID: userID,
			DatabaseName: databaseName,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(deleteInstrumentDetails, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(deleteInstrumentFailure(responseData.data));
		} else {
			yield put(deleteInstrumentSuccess(responseData.data));
		}
	} catch (error) {
		yield put(deleteInstrumentFailure(error));
	}
}

export function* resetDeleteInstrumentResponse() {
	yield put(deleteInstrumentResponseChanged());
}

export function* onDeleteInstrument() {
	yield takeLatest(InstrumentActionTypes.DELETE_INSTRUMENT_START, deleteInstrument);
}

export function* onDeleteInstrumentResponseReset() {
	yield takeLatest(
		InstrumentActionTypes.DELETE_INSTRUMENT_RESPONSE_RESET,
		resetDeleteInstrumentResponse,
	);
}
/************************** END - DELETE INSTRUMENT DETAILS ***************************/

/************************** START -  UPDATE INSTRUMENT DETAILS ************************/
export function* UpdateInstrument({ payload }: any) {
	try {
		const key = 'UpdateInstrumentDetailsKey';
		const { infogCompanyID, instrumentID, instrumentName, userID, userName, databaseName } =
			payload;
		const jsonData = {
			InstrumentID: instrumentID,
			InstrumentName: instrumentName,
			InfogID: infogCompanyID,
			UserName: userName,
			UserID: userID,
			DatabaseName: databaseName,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(updateInstrumentDetails, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(updateInstrumentFailure(responseData.data));
		} else {
			yield put(updateInstrumentSuccess(responseData.data));
		}
	} catch (error) {
		yield put(updateInstrumentFailure(error));
	}
}

export function* ResetupdateInstrumentResponse() {
	yield put(updateInstrumentResponseChanged());
}

export function* onUpdateInstrument() {
	yield takeLatest(InstrumentActionTypes.UPDATE_INSTRUMENT_START, UpdateInstrument);
}

export function* onupdateInstrumentResponseReset() {
	yield takeLatest(
		InstrumentActionTypes.UPDATE_INSTRUMENT_RESPONSE_RESET,
		ResetupdateInstrumentResponse,
	);
}
/**************************** END -  UPDATE INSTRUMENT DETAILS **************************/

/************************ ROOT SAGA **********************/
export function* instrumentSaga() {
	yield all([
		// GET INSTRUMENT LIST RESPONSE
		call(onGetAllInstruments),
		call(onGetAllInstrumentResponseReset),
		// CREATE INSTRUMENT RESPONSE
		call(onCreateInstrument),
		call(onCreateInstrumentResponseReset),
		// GET INSTRUMENT LIST RESPONSE
		call(onGetParticularInstrument),
		call(ongetParticularInstrumentResponseReset),
		// DELETE INSTRUMENT RESPONSE
		call(onDeleteInstrument),
		call(onDeleteInstrumentResponseReset),
		// UPDATE INSTRUMENT RESPONSE
		call(onUpdateInstrument),
		call(onupdateInstrumentResponseReset),
	]);
}
